export const OtcStatus = {
    ACTIVE: 'active',
    CONSUMED: 'consumed',
    REVOKED: 'revoked',
    EXPIRED: 'expired',
    INACTIVE: 'inactive'
};
